import React from "react";

import css from "./HomePage.module.css";
import RochaPerfil from "../../assets/RochaPerfil.png";
import { Head } from "../../Utils/Head";
import { Navbar } from "../Layout/Navbar";

export const About = () => {
  return (
    <>
      <Head title="Home" description="Home - Mairimed" />
      <div className={css.container}>
        <Navbar />
        <section className={css.audioTop}>
          <h1>Sobre a Abordagem Terapêutica</h1>
        </section>
        <section className={css.audioContent}>
          <div className={css.audioContainer}>
            {/* <img src={RochaPerfil} alt="" /> */}
            <h3>Thiago Rocha</h3>
            <p>
              Como psiquiatra e psicoterapeuta, compreende o sofrimento humano a
              partir de uma perspectiva integrativa, que respeita a
              singularidade de cada pessoa e se baseia em evidências científicas
              sólidas. A prática clínica é guiada pelas{" "}
              <trong>terapias comportamentais contextuais</trong>, especialmente
              a <strong>Terapia de Aceitação e Compromisso (ACT)</strong> e a{" "}
              <strong>Psicoterapia Analítica Funcional (FAP)</strong>.
            </p>

            <p>
              Essas abordagens fazem parte da chamada{" "}
              <strong>terceira geração da terapia comportamental</strong>, que
              vai além da modificação direta de comportamentos. Elas focam no
              contexto em que esses comportamentos ocorrem e promovem um
              processo de mudança mais profundo e duradouro, alinhado aos
              valores pessoais de cada indivíduo.
            </p>

            <p>
              Mestre em Ciências do Comportamento pelo Instituto de Psicologia
              da Universidade de Brasília, com foco em{" "}
              <strong>
                Teoria das Molduras Relacionais (Relational Frame Theory – RFT)
              </strong>
              , uma teoria que oferece uma base explicativa para o funcionamento
              da linguagem e da cognição humana. Essa teoria é o alicerce
              teórico da ACT e ajuda a entender como o modo como falamos e
              pensamos pode contribuir tanto para o sofrimento quanto para a
              construção de uma vida mais significativa.
            </p>

            <p>
              Atualmente, coordena o Ambulatório de Psicoterapias da Secretaria
              de Saúde, onde também ministra a disciplina de terapias
              comportamentais contextuais para médicos residentes em
              psiquiatria. Além do trabalho clínico, atua como professor da
              faculdade de medicina da UnB.
            </p>

            <h3>ACT: Aceitação e Compromisso</h3>

            <p>
              A ACT não busca eliminar sintomas a qualquer custo, mas sim ajudar
              a pessoa a desenvolver <strong>flexibilidade psicológica</strong>{" "}
              – a capacidade de estar presente, aceitar sua experiência interna
              e agir de forma comprometida com aquilo que realmente importa. O
              foco é ajudar a pessoa a construir uma vida mais rica, mesmo na
              presença da dor.
            </p>

            <h3>FAP: Psicoterapia Analítica Funcional</h3>

            <p>
              Já a FAP é uma abordagem que utiliza o próprio relacionamento
              terapêutico como um contexto poderoso de mudança. Por meio de
              interações autênticas e intencionais, ela favorece o
              desenvolvimento de novos repertórios relacionais e emocionais no
              aqui e agora da sessão.
            </p>

            <h3>Um convite ao autoconhecimento</h3>
            <p>
              Se você busca uma psicoterapia fundamentada em ciência, mas também
              profundamente humana, essa abordagem pode ajudá-lo a se reconectar
              com seus valores e com aquilo que torna a vida verdadeiramente
              significativa.
            </p>
          </div>
        </section>

        <footer className={css.footer}>
          {/* <div className={css.footerLinks}>
                            <a href="#">Privacidade</a>
                            <a href="#">Termos de uso</a>
                          </div> */}
          {/* <div className={css.footerSocial}>
                            <a href="#">
                              <ion-icon
                                name="logo-facebook"
                                className="icon"
                                alt="Facebook"
                              ></ion-icon>
                            </a>
                            <a href="#">
                              <ion-icon
                                name="logo-twitter"
                                className="icon"
                                alt="Twitter"
                              ></ion-icon>
                            </a>
                            <a href="#">
                              <ion-icon
                                name="logo-linkedin"
                                className="icon"
                                alt="LinkedIn"
                              ></ion-icon>
                            </a>
                          </div> */}
          <div className={css.footerContact}>
            {/* <p>Email: info@educationalplatform.com</p> */}
            {/* <p>Phone: +55 61 92492842</p> */}
          </div>
          <div className={css.newsletterSignup}>Mairini © 2025</div>
        </footer>
      </div>
    </>
  );
};
